module.exports = __webpack_public_path__ + "static/media/06-10.e2fde030.png";